import Typography from "@mui/material/Typography";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import { useState } from "react";
import UnlockCard from "./UnlockCard";
import { PurchaseCard } from "../redux/slices/finchatSlice";

const joinWithAnd = (items: string[]) => {
  if (items.length <= 1) return items[0] ?? "";
  return `${items.slice(0, -1).join(", ")} and ${items[items.length - 1]}`;
};

const humanizeToolId = (toolId: string) => toolId.replace(/^(get|fetch)_/, "").replace(/_/g, " ");

const LimitedDataHeader = ({ blockedToolIds, purchaseCards }: { blockedToolIds: string[]; purchaseCards: PurchaseCard[] }) => {
  const [expanded, setExpanded] = useState<boolean>(false);

  const bundleNames = purchaseCards.map(card => card.bundle_name);
  const headline = bundleNames.length
    ? `Completed with limited data — unlock ${joinWithAnd(bundleNames)} for full analysis`
    : "Completed with limited data";
  const blockedToolNames = blockedToolIds.map(humanizeToolId);

  return (
    <div className="rounded-lg border border-amber-200 dark:border-amber-900/50 bg-amber-50/50 dark:bg-amber-950/20 mb-3 overflow-hidden">
      <button
        type="button"
        onClick={() => setExpanded(prevState => !prevState)}
        className="w-full flex items-center gap-2 px-3 py-2 text-left hover:bg-amber-50 dark:hover:bg-amber-950/30 transition-colors"
      >
        <InfoOutlinedIcon className="!w-4 !h-4 text-amber-600 dark:text-amber-400 shrink-0" />
        <Typography variant="caption" className="flex-1 text-amber-800 dark:text-amber-200">{headline}</Typography>
        <ExpandMoreRoundedIcon className={`!w-4 !h-4 text-amber-600 dark:text-amber-400 transition-transform ${expanded ? "rotate-180" : ""}`} />
      </button>
      {expanded && (
        <div className="px-3 pb-3 pt-1.5">
          {blockedToolNames.length > 0 && (
            <Typography variant="caption" component="p" className="text-amber-700/70 dark:text-amber-300/70 !mb-2">
              Could not access
              {" "}
              {joinWithAnd(blockedToolNames)}
            </Typography>
          )}
          <div className="flex flex-wrap gap-2">
            {purchaseCards.map(card => (
              <UnlockCard
                key={card.bundle_id}
                variant="compact"
                bundleName={card.bundle_name}
                price={card.price}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default LimitedDataHeader;
